
import api from '@/plugins/api'
import Download from '~/components/type/Download'
import Collect from '~/components/type/Collect'
import { openUrl } from '~/plugins/util'
export default {
    props: {
        list: { type: Array, default: () => [] },
        type: { type: Number, default: 1 }, // 图片类型 1人物 2景点 3事件 4风采照
        from: { type: String, default: '' }, // 有值--来自个人中心（dowm下载记录  buy:购买记录）
    },
    components: { Download, Collect },
    data() {
        return {
            height: 800
        };
    },
    watch: {
    },
    created() {
    },
    methods: {
      toDetail(item) {
        let params = {
          from: 'pic',
          type: this.from ? item.attach_class || this.type : this.type,
          id: item.product_id || item.attach_id || item.id || ''
        };
        if(this.type == 4 || item.attach_class == 4) params.name = item.title || item.attach_name;
        openUrl(this.$router, {
            path: `/material/detail`,
            query: params
        })
      },

      // 购买记录中操作 order_status: 0 未支付 1 已支付 2 取消
      buyBtn(item) {
        if(item.order_status == 1) {
          this.toDownLoad(item);
          return;
        }

        let params = { id: item.product_id };
        if(item.order_status == 0) params.oid = item.order_id;
        openUrl(this.$router, {
             path: `/pay`,
            query: params
        })
      },

      getFigureType(type) {
        switch (type) {
          case 1:
            return "类别：红色人物";
          case 2:
            return "类别：新时代人物";
          case 3:
            return "类别：关联人物";
          default:
            return "";
        }
      },

      getBuyBtnText(item) {
        let status = item.order_status + '';
        switch(status){
          case '0':return '继续支付';
          case '1':return '立即下载';
          case '2':return '重新购买';
          default:return '立即下载';
        }
      },

      getBuyBtnStatus(item) {
        let status = item.order_status + '';
        switch(status){
          case '0': return '待支付';
          case '1':return '已购买';
          case '2':return '已取消';
          default: return '';
        }
      },

      toDownLoad(item) {
        this.$axios.$post(api.downloadImage, { id: item.id || item.attach_id || item.product_id })
        .then(data => {
            if(!data || !data.info || !data.info.downurl) return this.$message.error('啊哦，网络走丢了~ 请稍后再试！')
            location.href = data.info.downurl;
        })
        .catch(err => {
            this.$message.error(err || '啊哦~网络在开小差，请稍后再试！');
        });
      }
    }
};
